
import { TriState } from '../actions/toolbar'
export const ClickEvent = Object.freeze({ SingleClick: 0, DoubleClick: 1 })

/**
 * Shifts between various states of TriState, depending on the incoming event
 */
export class TriStateShifter {
  static shiftState (currentState, clickEvent) {
    let newState
    if (clickEvent === ClickEvent.SingleClick) {
      newState = currentState === TriState.Inactive
        ? TriState.Active
        : TriState.Inactive

    } else if (clickEvent === ClickEvent.DoubleClick) {
      newState = currentState === TriState.AlwaysOn
        ? TriState.Inactive
        : TriState.AlwaysOn

    } else {
      newState = currentState
    }

    return newState
  }
}
